import React from "react";
import StatusBadge from "@/components/StatusBadge";
import { BannerPreviewModal } from "@/components/BannerEditorModal/BannerPreviewModal";
import { bannersApi } from "@/apis/apis";

const Columns = () => {
  const columns = [
    {
      accessorKey: "status",
      header: "Status",
      cell: ({ row }) => <StatusBadge status={row.getValue("status")} />,
    },
    {
      accessorKey: "order",
      header: "Order",
      size: 60,
      cell: ({ row }) => (
        <div className="flex justify-center">{row.getValue("order")}</div>
      ),
    },
    {
      accessorKey: "name",
      header: "Name",
    },
    {
      accessorKey: "sport",
      header: "Sport",
      cell: ({ row }) => <div>{row.original.sport?.name || "SP-All"}</div>,
    },
    {
      accessorKey: "page",
      header: "Page",
    },
    {
      accessorKey: "language",
      header: "Language",
      cell: ({ row }) => (
        <>
          <div className="uppercase">
            {row.original.language?.code
              ? row.original.language?.code
              : row.original.language_type === "all"
              ? "All"
              : "All-EN"}
          </div>
        </>
      ),
    },
    {
      accessorKey: "image_url",
      header: "Preview",
      enableSorting: false,
      cell: ({ row }) =>
        row.original?.image_url && (
          <BannerPreviewModal
            api={bannersApi}
            data={row.original}
            image_url={row.original?.image_url}
          />
        ),
    },
    {
      accessorKey: "url_redirect",
      header: "Url Redirect",
      cell: ({ row }) => (
        <a
          href={row.original.url_redirect}
          className="underline text-blue-800"
          target="_blank"
          rel="noreferrer"
        >
          {row.original.url_redirect}
        </a>
      ),
    },
  ];

  return columns;
};

export default Columns;
